import type { ReactNode, MouseEventHandler } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { MeaningfulBehaviourDataWrapper } from '../../contexts/meaningful-behaviour-data';
import ProgressivePictureItem from '../ProgressivePictureItem';

import type { MBDProps } from '@shared/types/frontend/meaningful-behaviour-data';
import type { Nullable } from '@shared/types/utils';

import STYLES from './ProgressivePictureButton.module.scss';

type Props = {
  src: string;
  alt: string;
  className?: string;
  lowQualityClassName?: string;
  containerButtonClassName?: string;
  dataTestId?: Nullable<string>;
  showShimmerAnimation?: boolean;
  ariaHidden?: boolean;
  ariaLabel?: string;
  lazyLoad?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sources: Array<{
    media?: string;
    srcSet: string[];
  }>;
  children?: ReactNode;
  mbdProps?: MBDProps;
};

const cls = cssModules(STYLES);

const ProgressivePictureButton = ({
  alt,
  ariaHidden = false,
  ariaLabel,
  children,
  className,
  containerButtonClassName,
  dataTestId,
  lazyLoad,
  lowQualityClassName,
  mbdProps,
  onClick = () => {},
  showShimmerAnimation,
  sources,
  src,
}: Props) => (
  <MeaningfulBehaviourDataWrapper {...mbdProps}>
    <button
      type="button"
      data-test-id={dataTestId}
      aria-hidden={ariaHidden}
      aria-label={ariaLabel}
      className={cls('ProgressivePictureButton', containerButtonClassName)}
      onClick={onClick}
    >
      <ProgressivePictureItem
        lowQualityClassName={lowQualityClassName}
        className={className}
        showShimmerAnimation={showShimmerAnimation}
        lazyLoad={lazyLoad}
        sources={sources}
        src={src}
        alt={alt}
      />
      {children}
    </button>
  </MeaningfulBehaviourDataWrapper>
);

export default ProgressivePictureButton;
